// extracted by mini-css-extract-plugin
module.exports = {"container":"TwoColumnsLayout_container__2GiyS","main":"TwoColumnsLayout_main__PEHBT","right":"TwoColumnsLayout_right__SIdQW"};